<form class="m-h-12 m-v-32"
    [formGroup]="form">
    <h3>{{ 'sigt.integration.rapportCommentaires.form.title' | translate }}</h3>

    <mat-form-field class="d-flex">
        <mat-label>{{ 'sigt.integration.rapportCommentaires.form.regions' | translate }}</mat-label>
        <mat-select multiple
            formControlName="regions">
            <mat-option *ngFor="let entry of listeRegion"
                [value]="entry.valeur">{{ entry.description }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="d-flex">
        <mat-label>{{ 'sigt.integration.rapportCommentaires.form.plans' | translate }}</mat-label>
        <mat-select formControlName="typePlan">
            <mat-option *ngFor="let entry of listeTypeDePlan"
                [value]="entry.valeur">{{ entry.description }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-grid-list class="tour-interactif-step-0-step-3"
        cols="2"
        rowHeight="2:1">
        <mat-grid-tile>
            <mat-form-field class="d-flex">
                <mat-label>{{ 'sigt.integration.rapportCommentaires.form.du' | translate }}</mat-label>
                <input matInput
                    formControlName="dateDebut"
                    [matDatepicker]="pickerDateDebut"
                    [max]="today">
                <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
                <mat-datepicker-toggle matIconSuffix
                    [for]="pickerDateDebut"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateDebut></mat-datepicker>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field class="d-flex">
                <mat-label>{{ 'sigt.integration.rapportCommentaires.form.au' | translate }}</mat-label>
                <input matInput
                    formControlName="dateFin"
                    [matDatepicker]="pickerDateFin"
                    [max]="today">
                <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
                <mat-datepicker-toggle matIconSuffix
                    [for]="pickerDateFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateFin></mat-datepicker>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>
    <mat-error *ngIf="form.errors?.dateDebutFinErreur">
        {{form.errors?.dateDebutFinErreur.message}}
    </mat-error>

    <div class="boutons-en-grille">
        <button mat-raised-button
            class="clear-search-button tour-interactif-rde-reinitialiser"
            (click)="initialiserChamps()">
            {{ 'sigt.global.boutons.reinitialiser' | translate }}
        </button>

        <button mat-raised-button
            class="search-button tour-interactif-rde-rechercher"
            [disabled]="!form.valid"
            (click)="rechercher()"
            color="primary">
            {{ 'sigt.global.boutons.rechercher' | translate }}
        </button>
    </div>
</form>
